export default __webpack_public_path__ + "static/media/terraces.8524d714.svg";